import { MenuItem } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, Select } from "@blueprintjs/select";
import * as React from "react";

interface IAjuste {
  id: string
  _id: string
  nome: string
}
export const AjusteSelect = Select.ofType<IAjuste>();

export const filterItensAjustes: ItemPredicate<IAjuste> = (query, item) => {

  return item.nome.toLowerCase().indexOf(query.toLowerCase()) >= 0;

};

export const returnLabel = (item: IAjuste) => {

  let new_label = `${item.nome}`

  return (<div style={{ width: "100%" }} title={new_label}>{new_label}</div>)

}

export const renderItensAjustes: ItemRenderer<IAjuste> = (item, { handleClick, modifiers }) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <MenuItem
      active={modifiers.active}
      key={item.id}
      text={returnLabel(item)}
      onClick={handleClick}
    />
  );
};
